import { render, staticRenderFns } from "./combinationProduct.vue?vue&type=template&id=4d761a15&scoped=true"
import script from "./combinationProduct.vue?vue&type=script&lang=js"
export * from "./combinationProduct.vue?vue&type=script&lang=js"
import style0 from "./combinationProduct.vue?vue&type=style&index=0&id=4d761a15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d761a15",
  null
  
)

export default component.exports